import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/apiClient';
import type { AiReleaseNotesSummary } from '../types/aiReleaseNotes';

export const useAiSummary = (releaseId: string | undefined) => {
  return useQuery<AiReleaseNotesSummary | null>({
    queryKey: ['aiSummary', releaseId],
    queryFn: async () => {
      try {
        return await apiClient.getAiSummary(releaseId!);
      } catch (error: any) {
        if (error?.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!releaseId,
    staleTime: 2 * 60 * 1000,
  });
};

export const useGenerateAiSummary = () => {
  const queryClient = useQueryClient();

  return useMutation<AiReleaseNotesSummary, Error, string>({
    mutationFn: (releaseId: string) => apiClient.generateAiSummary(releaseId),
    onSuccess: (data, releaseId) => {
      queryClient.setQueryData(['aiSummary', releaseId], data);
    },
  });
};
